/**
 * "VIEW AS" (the Follow-Ups nav right-click menu, `ViewAsNavMenu.vue`, and the
 * client-only scope `composables/usePlanningImportScope.js` keeps) — the pure
 * rules: the storage key, the stored shape, the peer's label.
 */

/** localStorage key prefix for the per-user "viewing planning of X" scope. */
export const PLANNING_IMPORT_SCOPE_PREFIX = 'planningImportScope:'

export function planningScopeStorageKey(userId) {
  return `${PLANNING_IMPORT_SCOPE_PREFIX}${userId ?? 'anon'}`
}

/** What a stored value hydrates to: the scope when it names a user, else null. */
export function hydratedPlanningScope(saved) {
  return saved && saved.userId != null ? saved : null
}

/**
 * The scope as it is kept: `{ userId, label, color }` — the peer's own display
 * identity (User.label/color) — with the id as a string; null clears it.
 */
export function importedScopeOf({ userId, label, color } = {}) {
  return userId != null
    ? { userId: String(userId), label: label ?? null, color: color ?? null }
    : null
}

/** How the menu names a peer: label, else short name, else name. */
export function peerLabel(peer) {
  return peer?.label || peer?.shortName || peer?.name || ''
}

/** The scope a picked peer becomes. */
export function importedScopeFromPeer(peer) {
  return { userId: peer.id, label: peerLabel(peer), color: peer.color ?? null }
}
